import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Let everyone know there's been an error
    let errors = this.element.querySelectorAll(".error-text");
    this.dispatch("new", { detail: { errors: errors } });
  }
}